import React, { lazy, Suspense, useEffect, useState } from 'react'
import CaseNewDetailHead from './CaseNewDetailHead'
import { ApiEndpoints } from '../../helper/ApiEndpoints'
import { useParams } from 'react-router-dom'
import ApiRequest from '../../helper/ApiRequest'

const CaseNewDetailAbout = lazy(() => import("./CaseNewDetailAbout"));
const CaseNewDetailsLocation = lazy(() => import("./CaseNewDetailsLocation"));
const CaseNewDetailChallenge = lazy(() => import("./CaseNewDetailChallenge"));
const CaseNewDetailNumber = lazy(() => import("./CaseNewDetailNumber"));
const CaseNewDetailSolution = lazy(() => import("./CaseNewDetailSolution"));
const CaseNewDetailBuild = lazy(() => import("./CaseNewDetailBuild"));
const CaseNewDetailTech = lazy(() => import("./CaseNewDetailTech"));
const CaseNewDetailClient = lazy(() => import("./CaseNewDetailClient"));
const CaseNewDetailContact = lazy(() => import("./CaseNewDetailContact"));
const CaseNewDetailForm = lazy(() => import("./CaseNewDetailForm"));


const detailEndpoint = ApiEndpoints.newCase.caseStudyDetail;
export default function CaseNewDetails() {
  const { casestudy_slug } = useParams();
  const [data, setData] = useState({});
  const [isScroll, setIsScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsScroll(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const dataFetch = async () => {
      try {
        const response = await ApiRequest("GET", detailEndpoint + casestudy_slug);
        const result = response.newcasestudy;
        setData(result);
      } catch (error) {
        console.log(error);
      }
    };

    dataFetch();
  }, []);

  return (
    <>
      <CaseNewDetailHead data={data} />
      <Suspense fallback={null}>
        <CaseNewDetailAbout data={data} />
        {isScroll && (
          <>
            <CaseNewDetailsLocation data={data} />
            <CaseNewDetailChallenge data={data} />
            <CaseNewDetailSolution data={data} />
            <CaseNewDetailBuild />
            <CaseNewDetailNumber data={data} />
            <CaseNewDetailTech data={data} />
            <CaseNewDetailClient data={data} />
            <CaseNewDetailContact />
            <CaseNewDetailForm featureId="case-study-new" />
          </>
        )}
      </Suspense>
    </>
  )
}
